import { render, staticRenderFns } from "./CustomTitleDivider.vue?vue&type=template&id=37aefdfc&scoped=true"
import script from "./CustomTitleDivider.vue?vue&type=script&lang=js"
export * from "./CustomTitleDivider.vue?vue&type=script&lang=js"
import style0 from "./CustomTitleDivider.vue?vue&type=style&index=0&id=37aefdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aefdfc",
  null
  
)

export default component.exports